/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './day-off.reducer';

export const DayOffDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dayOffEntity = useAppSelector(state => state.dayOff.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dayOffDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dayOff.detail.title">DayOff</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dayOff.id">Id</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.id}</dd>
          <dt>
            <span id="requestedDate">
              <Translate contentKey="tinyMedicRestApp.dayOff.requestedDate">Requested Date</Translate>
            </span>
          </dt>
          <dd>
            {dayOffEntity.requestedDate ? (
              <TextFormat value={dayOffEntity.requestedDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.dayOff.type">Type</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.type}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dayOff.active">Active</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dayOff.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.dayOff.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dayOff.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.dayOff.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{dayOffEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dayOff.nurse">Nurse</Translate>
          </dt>
          <dd>{dayOffEntity.nurse ? dayOffEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/day-off" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/day-off/${dayOffEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DayOffDetail;
